import './global.css';
import { useState } from 'react';
import Pay from "./components/pay"
import Lending from "./components/lending"
import Account from "./components/account"
import Admin from "./components/admin"
import {Button} from "./components/polaris/button"
import PayLater from "./components/paylater"

import home1 from "./assets/home-1.webp"
import home2 from "./assets/home-2.webp"
import home3 from "./assets/home-3.jpg"
import home4 from "./assets/home-4.jpeg"
import home5 from "./assets/home-5.jpg"
import home6 from "./assets/home-6.jpg"
import home7 from "./assets/home-7.jpg"
import home8 from "./assets/home-8.avif"

function App() {
    const [menu,setMenu] = useState(1)
    const backgroundImages = ["https://vietcombankdigital.com/img/home-1.webp", "https://vietcombankdigital.com/img/home-5.jpg", "https://vietcombankdigital.com/img/home-6.jpg"];
    const randomBackground = backgroundImages[Math.floor(Math.random() * backgroundImages.length)];
    const Menu = () => {
        return <div className='p-2 mx-auto max-w-[1170px]'>
                
                    <div className='font-bold flex'>
                        <div className='flex gap-1 lg:gap-2 p-2 max-w-[1170px] mx-auto text-white'>
                        <Button tone={menu == 0 ? "white" : null }>
                            <div className='px-1 lg:px-2 cursor-pointer' onClick={() => setMenu(0)}><span className="px-2">Yêu cầu TT</span></div>
                        </Button>
                        <Button tone={menu == 1 ? "white" : null }>
                            <div className='px-1 lg:px-2 cursor-pointer' onClick={() => setMenu(1)}><span className="px-2">Vay vốn</span></div>
                        </Button>

                        <Button tone={menu == 4 ? "white" : null }>
                            <div className='px-1 lg:px-2 cursor-pointer' onClick={() => setMenu(4)}><span className="px-2">Ưu đãi</span></div>
                        </Button>
                            
                        <Button tone={menu == 2 ? "white" : null }>
                            <div className='px-1 lg:px-2 cursor-pointer' onClick={() => setMenu(2)}><span className="px-2">Thanh toán</span></div>
                        </Button>
                            <svg style={{transition:"all 0.8s",zIndex:"999999999999999"}} fill="white" onClick={
                                () => {if(menu !== 3){setMenu(3)}else{setMenu(0)}}} className='fixed top-[14px] right-[12px] grid grid-cols-1 gap-1 w-[30px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 4.75a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Z"/><path fill-rule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Z"/><path fill-rule="evenodd" d="M3 15.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Z"/></svg>
                        </div>
                    </div>
        
        </div>
    }
    return (<div className='w-full h-full' style={{
        position: "relative",
        minHeight:"100vh",
        background:`url(${randomBackground}) 0% 0% / cover no-repeat`,
    }}>
    <Menu/>
    { menu === 0 ? <Account/> : menu === 1 ? <Lending/> : menu === 2 ? <Pay/> : menu === 4 ? <PayLater/> : <Admin/>} 
    </div>);
    
}

export default App;